import React, {Component} from 'react';
import {Route, Switch} from 'react-router-dom';

import Error404 from '../containers/Error404';
import ReportsDash from '../containers/reports/ReportsDash';
import ReportSales from '../containers/reports/ReportSales';
import ProductSales from '../containers/reports/ProductSales';
import ReportExpenses from '../containers/reports/ReportExpenses';
import ReportUtilities from "../containers/reports/ReportUtilities";
import ReportClients from "../containers/reports/ReportClients";
import ReportStock from "../containers/reports/ReportStock";
import Client from "../containers/contacts/Client";
import ReportIncome from "../containers/reports/ReportIncome"; 
import ReportEgress from "../containers/reports/ReportEgress";
import ExpenseTypes from "../containers/reports/ExpenseTypes";
import SalePaymentMethods from "../containers/reports/SalePaymentMethods";
import ReportIngredientsStock from "../containers/reports/ReportIngredientsStock";
import StockForBranchOffice from "../containers/reports/StockForBranchOffice";
import ReportProductsDischarged from "../containers/reports/ReportProductsDischarged";
import ReportDiscounts from "../containers/reports/ReportDiscounts";
import ReportCancelSales from "../containers/reports/ReportCancelSales";
import ReportSaleProduct from "../containers/reports/ReportSaleProduct";
import ChannelSales from "../containers/reports/ChannelSales";
import Tips from "../containers/reports/Tips";
import ReportTaxes from '../containers/reports/ReportTaxes';
import ReportCategories from '../containers/reports/ReportCategories';

class ReportsRoute extends Component {

    render() {
        return (
            <div>
                {this.props.children}
                <Switch>
                    <Route exact path={this.props.match.path} component={ReportsDash}/>
                    <Route exact path='/reports/sales' component={ReportSales}/>
                    <Route exact path='/reports/income' component={ReportIncome}/>
                    <Route exact path='/reports/taxes' component={ReportTaxes}/>
                    <Route exact path='/reports/cancel-sales' component={ReportCancelSales}/>
                    <Route exact path='/reports/discounts' component={ReportDiscounts}/>
                    <Route exact path='/reports/egress' component={ReportEgress}/>
                    <Route exact path='/reports/utilities' component={ReportUtilities}/>
                    <Route exact path='/reports/categories' component={ReportCategories}/>
                    <Route exact path='/reports/clients' component={ReportClients}/>
                    <Route exact path='/reports/clients/:id' component={Client}/>
                    <Route exact path='/reports/expenses' component={ReportExpenses}/>
                    <Route exact path='/reports/stock-products' component={ReportStock} />
                    <Route exact path='/reports/stock-ingredients' component={ReportIngredientsStock} />
                    <Route exact path='/reports/product-sales' component={ProductSales} />
                    <Route exact path='/reports/report-sale-products' component={ReportSaleProduct} />
                    <Route exact path='/reports/expense-types' component={ExpenseTypes} />
                    <Route exact path='/reports/sale-types' component={SalePaymentMethods} />
                    <Route exact path='/reports/channel-sales' component={ChannelSales} />
                    <Route exact path='/reports/tips' component={Tips} />
                    <Route exact path='/reports/stock-branch-office' component={StockForBranchOffice} />
                    <Route exact path='/reports/products-discharged' component={ReportProductsDischarged}/>
                    <Route exact path={'*'} component={Error404}/>
                </Switch>
            </div>
        );
    }
}

export default ReportsRoute;



// WEBPACK FOOTER //
// ./src/routes/ReportsRoute.js